import React from 'react'

function FacebookIcon () {
  return (
    <div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='38'
        height='38'
        viewBox='0 0 38 38'
      >
        <g
          id='Group_12433'
          data-name='Group 12433'
          transform='translate(-16 -146)'
        >
          <rect
            id='Rectangle_5755'
            data-name='Rectangle 5755'
            width='38'
            height='38'
            rx='9'
            transform='translate(16 146)'
            fill='#385997'
          />
          <path
            id='Path_14804'
            data-name='Path 14804'
            d='M40.028,19.619h-5.01V15.812c0-.932,1.072-1,1.4-1h3.407V9.6H36.421a6.279,6.279,0,0,0-6.613,6.212v3.807H25.6v5.21h4.208V36.852h5.21V24.829h4.208Z'
            transform='translate(7.718 146.839)'
            fill='#fff'
          />
        </g>
      </svg>
    </div>
  )
}

export default FacebookIcon
